import auth from "../../middlewares/auth";
export const magazineSlidersRoute = [
  {
    path: '/magazine_slider/list',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/magazine_sliders/MagazineSliderList'),
    name: 'magazine_slider_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/magazine_slider/add',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/magazine_sliders/MagazineSliderForm'),
    name: 'magazine_slider_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/magazine_slider/edit/:id',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/magazine_sliders/MagazineSliderForm'),
    name: 'magazine_slider_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];